import { createFeature } from '@ngrx/store';

import { AppNotification } from 'src/app/models/app-notification.model';

import NotificationReducer from './reducer';

export interface NotificationState {
  notifications: AppNotification[] | undefined;
}

export const notificationFeatureKey = 'notification';

export const notificationFeature = createFeature({
  name: notificationFeatureKey,
  reducer: NotificationReducer,
});
